module.exports = __webpack_public_path__ + "static/media/asset-operation.ebf33815.svg";